// extracted by mini-css-extract-plugin
export default {"PostDetailRight__searchPanel":"ql_a bhp_sw bhp_kx bhp_ky","PostDetailRight__brandDaysPosts":"ql_b bhp_sw bhp_kx bhp_ky"};